import DOMPurify from 'dompurify';

/**
 * Sanitiza strings HTML para prevenir vulnerabilidades de XSS (Cross-Site Scripting).
 * 
 * @param dirty - Conteúdo HTML não confiável
 * @returns HTML sanitizado e seguro para renderização
 */
export function sanitizeHtml(dirty: string): string {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      'p', 'br', 'b', 'i', 'em', 'strong', 'a', 'ul', 'ol', 'li',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'blockquote', 'hr'
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style', 'title'],
    ALLOW_DATA_ATTR: false,
  });
}
